import { Model, tProp, types } from "mobx-keystone";
import { bankNS } from "./ns";

@bankNS.model
export default class BankModel extends Model({
  name: tProp(types.string),
  svg: tProp(types.maybeNull(types.string)),
  countryCode: tProp(types.maybeNull(types.string)),
  enabled: tProp(types.maybeNull(types.boolean), () => true),
  routingNumbers: tProp(types.array(types.string), () => []),
}) {}
